import React from 'react';
import { Separator } from '../ui/separator';
import { Linkedin, Youtube } from 'lucide-react';

const LegalFooter = () => {
  return (
    <footer className="bg-[#112d56] text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_vioq-content-update/artifacts/w40y3694_Smart%20AI%20Logo%20white.png"
                alt="Smart AI Solutions"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-blue-200 leading-relaxed mb-8 max-w-xs">
              AI-powered voice & knowledge solutions for modern businesses. Driving efficiency and customer excellence.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/in/smataisolutionstech/" target="_blank" rel="noopener noreferrer" className="text-blue-200 hover:text-[#ff7a1f] transition-colors">
                <Linkedin className="h-6 w-6" />
              </a>
              <a href="https://www.youtube.com/channel/UCij66Z3ffQtVIw3aIqNVN0g" target="_blank" rel="noopener noreferrer" className="text-blue-200 hover:text-[#ff7a1f] transition-colors">
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-xl mb-6 text-white">VioSuite Products</h4>
            <ul className="space-y-3 text-blue-200">
              <li><a href="/products/vioqbase" className="hover:text-[#ff7a1f] transition-colors text-lg">VioQbase</a></li>
              <li><a href="/products/vioreceptionist" className="hover:text-[#ff7a1f] transition-colors text-lg">VioReceptionist</a></li>
              <li><a href="/products/vioconcierge" className="hover:text-[#ff7a1f] transition-colors text-lg">VioConcierge</a></li>
              <li><a href="/products/viocoach" className="hover:text-[#ff7a1f] transition-colors text-lg">VioCoach</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-xl mb-6 text-white">Solutions</h4>
            <ul className="space-y-3 text-blue-200">
              <li><a href="/hr-consultancy" className="hover:text-[#ff7a1f] transition-colors text-lg">HR Consultancy</a></li>
              <li><a href="/features" className="hover:text-[#ff7a1f] transition-colors text-lg">Features</a></li>
              <li><a href="/use-cases" className="hover:text-[#ff7a1f] transition-colors text-lg">Use Cases</a></li>
              <li><a href="/about" className="hover:text-[#ff7a1f] transition-colors text-lg">About</a></li>
              <li><a href="/contact" className="hover:text-[#ff7a1f] transition-colors text-lg">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-xl mb-6 text-white">Legal</h4>
            <ul className="space-y-3 text-blue-200">
              <li><a href="/privacy" className="hover:text-[#ff7a1f] transition-colors text-lg">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-[#ff7a1f] transition-colors text-lg">Terms of Service</a></li>
              <li><a href="/cookies" className="hover:text-[#ff7a1f] transition-colors text-lg">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
        
        <Separator className="bg-blue-800/50 my-8" />
        
        <div className="text-center">
          <p className="text-blue-200 text-lg">
            © 2025 Smart AI Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;